import Swiper from "swiper";
import { Navigation, Scrollbar, A11y, Keyboard } from "swiper/modules";
import "swiper/css";

const gap = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--pk-slider-gap")) || 24;

export function createSlider(layout, selector, options = {}) {
	const el = layout.querySelector(selector);
	if (!el || el.swiper) return el?.swiper;

	return new Swiper(el, {
		modules: [Navigation, Scrollbar, A11y, Keyboard],
		slidesPerView: "auto",
		spaceBetween: gap(),
		grabCursor: true,
		watchOverflow: true,
		navigation: {
			prevEl: layout.querySelector(".pk-slider-button--prev"),
			nextEl: layout.querySelector(".pk-slider-button--next"),
		},
		scrollbar: { el: layout.querySelector(".pk-slider-progress"), draggable: true },
		keyboard: { enabled: true, onlyInViewport: true },
		a11y: {
			enabled: true,
			prevSlideMessage: el.dataset.prevLabel,
			nextSlideMessage: el.dataset.nextLabel,
		},
		...options,
	});
}
